<template>
  <div class="pepper-topic">
    <SectionLabel text="牽動選情"/>
    <!-- headline topics -->
    <div class="pepper-topic__headline">
      <div class="pepper-topic__item" v-for="topic in topicsTop3" :key="topic.id">
        <div class="pepper-topic__content clearfix">
          <div class="pepper-topic__photo" :style="`background-image: url(${topic.image})`"></div>
          <div class="pepper-topic__overview">
            <h3 class="pepper-topic__title">
              <span>{{ topic.title | line(0) }}</span>
              <span>{{ topic.title | line(1) }}</span>
            </h3>
            <div class="pepper-topic__summary">{{ topic.description | ellipsis }}</div>
            <div class="pepper-topic__detail"><!--
            --><OutlinesButton text="詳細內文" @click.native.prevent="onClick(topic.id)"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionLabel from '@/components/SectionLabel'
import OutlinesButton from '@/components/OutlinesButton'
import topics from '@/data/topics'

export default {
  name: 'PepperTopic',
  components: {
    SectionLabel,
    OutlinesButton
  },
  filters: {
    ellipsis (text, maxLen = 95) {
      let len = text.length
      if (len > maxLen) {
        return `${text.slice(0, maxLen)}...`
      }
      return text
    },
    line (text, lineNum = 0) {
      return text.split('\n')[lineNum] || ''
    }
  },
  data () {
    return {
      topics
    }
  },
  computed: {
    topicsTop3 () {
      return this.topics.slice(0, 3)
    }
  },
  methods: {
    onClick (id) {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Link',
        'eventAction': 'Click',
        'eventLabel': `Link-to-article-${id}`
      })
      console.log(`@${this.$options.name} [linktoOtherPage]`)
      this.$router.push({ name: `article-${id}` })
    }
  }
}
</script>

<style lang="scss">
.pepper-topic {
  $comp: &;
  @include use-layer(&);
  position: relative;
  min-height: 100vh;
  padding-bottom: 80px;
  background: #6a80d3;
  @include rwd($RWD_TABLET_SMALL) {
    padding-bottom: 100px;
  }
  @include rwd($RWD_TABLET) {
    padding-bottom: 125px;
  }
  @include rwd($RWD_DESKTOP) {
    padding-bottom: 100px;
  }
  @include rwd($RWD_DESKTOP_WIDE) {
    padding-bottom: 125px;
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 150%;
    border: 1px solid white;
    transform-origin: top right;
    transform: rotate(-45deg);
  }

  &__headline {
    @include rwd($RWD_TABLET_SMALL) {
      width: 520px;
      margin: 0 auto;
    }
    @include rwd($RWD_DESKTOP) {
      width: 850px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      // width: 82%;
      width: 1290px;
    }

    #{$comp}__item {
      margin-top: 46px;
      @include rwd($RWD_TABLET_SMALL) {
        margin-top: 57px;
      }
      @include rwd($RWD_TABLET) {
        margin-top: 57px;
      }
      @include rwd($RWD_DESKTOP) {
        margin-top: 40px;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        margin-top: 200px;
      }

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 160px;
        background: #e4007f;

        @include rwd($RWD_TABLET_SMALL) {
          height: 220px;
        }
        @include rwd($RWD_DESKTOP) {
          width: 131px;
          height: 100%;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          width: 210px;
          margin-top: -30px;
        }
      }

      &:first-child {
        margin-top: 51px;
        @include rwd($RWD_TABLET_SMALL) {
          margin-top: 70px;
        }
        @include rwd($RWD_TABLET) {
          margin-top: 73px;
        }
        @include rwd($RWD_DESKTOP) {
          margin-top: 67px;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          margin-top: 145px;
        }
      }

      #{$comp}__photo {
        @include rwd($RWD_DESKTOP) {
          width: 54.55%;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          top: -66px;
          width: 53.15%;
        }
      }

      #{$comp}__overview {
        @include rwd($RWD_DESKTOP) {
          width: 45.45%;
          height: 100%;
          padding: 5px 0;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          padding: 75px 0 60px 0;
          width: 46.85%;
        }
      }

      #{$comp}__detail {
        .outlines-button {
          @include rwd($RWD_DESKTOP) {
            position: absolute;
            bottom: 40px;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            bottom: 66px;
          }
        }
      }

      // odd
      &:nth-child(2n + 1) {
        #{$comp}__photo {
          @include rwd($RWD_DESKTOP) {
            float: left;
          }
        }
        #{$comp}__overview {
          @include rwd($RWD_DESKTOP) {
            float: right;
            padding-left: 25px;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            padding-left: 90px;
          }
        }
        #{$comp}__detail {
          .outlines-button {
            @include rwd($RWD_DESKTOP) {
              right: 40px;
            }
            @include rwd($RWD_DESKTOP_WIDE) {
              right: 78px;
            }
          }
        }
      }

      // even
      &:nth-child(2n) {
        @include rwd($RWD_DESKTOP_WIDE) {
          left: 75px;
        }

        &:before {
          @include rwd($RWD_DESKTOP) {
            left: auto;
            right: 0;
          }
        }
        #{$comp}__photo {
          @include rwd($RWD_DESKTOP) {
            float: right;
          }
        }
        #{$comp}__overview {
          @include rwd($RWD_DESKTOP) {
            float: left;
            padding-right: 25px;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            padding-right: 90px;
          }
        }
        #{$comp}__detail {
          .outlines-button {
            @include rwd($RWD_DESKTOP) {
              right: 54.55%;
              margin-right: 25px;
            }
            @include rwd($RWD_DESKTOP_WIDE) {
              right: 53.15%;
              margin-right: 90px;
            }
          }
        }
      }
    }
  }

  &__rest {
    position: relative;
    @include rwd($RWD_TABLET_SMALL) {
      width: 520px;
      margin: 0 auto;
    }

    &:before {
      content: "";
      display: block;
      position: absolute;
      top: -30px;
      bottom: -30px;
      width: 50%;
      background: #e4007f;
    }

    #{$comp}__item {
      margin-top: 56px;
    }
  }

  &__item {
    position: relative;
    background: url(~@/assets/background-dot.png) repeat top left;
  }

  &__content {
    position: relative;
    top: -12px;
    padding: 0 12px;

    @include rwd($RWD_TABLET_SMALL) {
      top: -17px;
      padding: 0 36px;
    }
    @include rwd($RWD_DESKTOP) {
      top: auto;
      padding: 40px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      padding: 0 78px;
      min-height: 478px;
    }
  }

  &__photo {
    position: relative;
    background: #f1f1f1 no-repeat top center / cover;
    @include use-fixed-ratio(4, 3);
  }

  &__overview {
    padding: 28px 18px 31px 18px;
    color: #1a1a1a;

    @include rwd($RWD_TABLET_SMALL) {
      padding: 31px 8px;
    }
  }

  &__title {
    // font-size: 1.25em;
    // font-weight: bold;
    // line-height: 1.4em;
    // letter-spacing: 0.125em;
    // @include rwd($RWD_TABLET_SMALL) {
    //   font-size: 1.5em;
    //   line-height: 1.167em;
    //   letter-spacing: 0.15em;
    // }
    // @include rwd($RWD_TABLET) {
    //   font-size: 1.875em;
    //   line-height: 1.2em;
    //   letter-spacing: 0.1em;
    // }
    // @include rwd($RWD_DESKTOP) {
    //   font-size: 1.5em;
    //   line-height: 1.5em;
    //   letter-spacing: 0.1em;
    // }
    // @include rwd($RWD_DESKTOP_WIDE) {
    //   font-size: 1.875em;
    //   line-height: 1.2em;
    //   letter-spacing: 0.1em;
    // }

    span {
      display: block;
      color: #1a1a1a;
      font-size: 1.25em;
      font-weight: bold;
      line-height: 1.2em;
      letter-spacing: 0.1em;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1.5em;
        line-height: 1.25em;
        letter-spacing: 0.1em;
      }
      @include rwd($RWD_TABLET) {
        font-size: 1.875em;
        line-height: 1.2em;
        letter-spacing: 0.1em;
      }
      @include rwd($RWD_DESKTOP) {
        font-size: 1.5em;
        line-height: 1.5em;
        letter-spacing: 0.1em;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        font-size: 1.875em;
        line-height: 1.2em;
        letter-spacing: 0.1em;
      }
    }

    span:first-child {
      color: #e4007f;
      font-size: 1em;
      line-height: 2.25em;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1.125em;
        line-height: 2em;
      }
      @include rwd($RWD_TABLET) {
        font-size: 1.25em;
        line-height: 1.5em;
      }
      @include rwd($RWD_DESKTOP) {
        font-size: 1.125em;
        line-height: 1.667em;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        font-size: 1.375em;
        line-height: 1.363em;
      }
    }

    span + span {
      margin-top: -2px;
      @include rwd($RWD_TABLET_SMALL) {
        margin-top: 0;
      }
      @include rwd($RWD_TABLET) {
        margin-top: 5px;
      }
      @include rwd($RWD_DESKTOP) {
        margin-top: -3px;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        margin-top: 7px;
      }
    }
  }

  &__summary {
    margin-top: 20px;
    font-size: 0.875em;
    font-weight: bold;
    text-align: justify;
    text-justify: inter-word;
    line-height: 1.714em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1em;
      line-height: 1.714em;
      letter-spacing: 0.1em;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 13px;
      font-size: 1.125em;
      line-height: 1.667em;
      letter-spacing: 0.1em;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 16px;
      font-size: 1em;
      line-height: 1.5em;
      letter-spacing: 0.1em;
      max-height: 9em;
      overflow: hidden;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 30px;
      font-size: 1.125em;
      line-height: 1.667em;
      letter-spacing: 0.1em;
      max-height: 8em;
    }
  }

  &__detail {
    width: 100%;
    margin-top: 32px;
    text-align: center;
    @include use-vertical-align();

    .outlines-button {
      vertical-align: middle;
      @include rwd($RWD_DESKTOP_WIDE) {
        width: 160px;
        height: 45px;
      }
      &__text {
        @include rwd($RWD_DESKTOP_WIDE) {
          font-size: 1.125em;
        }
      }
    }
  }
}
</style>
